module.exports = __webpack_public_path__ + "img/Butterfly_00343.611faa10.png";